var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0414 22.6055L25.7808 16.0015L31.0414 9.39755C31.3575 8.99116 31.1994 8.66378 30.6914 8.66378H28.682C28.5804 8.66378 28.4337 8.72022 28.3659 8.79925L21.5024 16.0015H21.0847L26.3452 9.39755C26.6613 8.99116 26.5033 8.66378 25.9953 8.66378H23.9972C23.8956 8.66378 23.7488 8.72022 23.6811 8.79925L16.8175 16.0015H16.3998L22.1345 8.81053C22.2023 8.73151 22.2361 8.58476 22.2135 8.48316L20.3735 0.43424C20.2606 -0.0737561 19.8993 -0.152778 19.5833 0.253619L14.3227 6.85757L6.71402 3.2C6.25118 2.97422 5.96896 3.2 6.08184 3.70799L7.95578 11.9375L0.347131 15.5951C-0.11571 15.8209 -0.11571 16.1821 0.347131 16.4079L7.95578 20.0655L6.08184 28.295C5.96896 28.803 6.25118 29.0288 6.71402 28.803L14.3227 25.1454L19.5833 31.7494C19.8993 32.1558 20.2606 32.0655 20.3735 31.5688L22.2474 23.3392H30.6914C31.1994 23.3392 31.3575 23.0006 31.0414 22.6055Z",
    fill: "#ED0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.041 22.6057L25.7804 16.0018L31.041 9.39783C31.3571 8.99144 31.199 8.66406 30.691 8.66406H28.6816C28.58 8.66406 28.4333 8.72051 28.3655 8.79953L21.502 16.0018H21.0843L26.3449 9.39783C26.6609 8.99144 26.5029 8.66406 25.9949 8.66406H23.9968C23.8952 8.66406 23.7484 8.72051 23.6807 8.79953L16.8171 16.0018H16.3994V27.7647L19.5716 31.7497C19.8877 32.1561 20.2489 32.0658 20.3618 31.569L22.2357 23.3395H30.6798C31.199 23.3395 31.3571 23.0008 31.041 22.6057Z",
    fill: "url(#paint0_linear_2634_7654)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0413 9.39783L25.7807 16.0018H21.5135L28.3771 8.79953C28.4449 8.72051 28.5916 8.66406 28.6932 8.66406H30.6913C31.1993 8.66406 31.3574 9.00273 31.0413 9.39783ZM25.9952 8.66406H23.9971C23.8955 8.66406 23.7487 8.72051 23.681 8.79953L16.8174 16.0018H21.0846L26.3451 9.39783C26.6725 9.00273 26.5145 8.66406 25.9952 8.66406Z",
    fill: "url(#paint1_linear_2634_7654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2634_7654",
    x1: 16.3973,
    y1: 20.3352,
    x2: 31.2054,
    y2: 20.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077335,
    stopColor: "#E90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    stopColor: "#D10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2634_7654",
    x1: 24.0118,
    y1: 16.0016,
    x2: 24.0118,
    y2: 8.66889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A50000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A50000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNabLogo);
export default __webpack_public_path__ + "static/media/nab-logo.7b0cf3e662d3146980d2ae4551df17e4.svg";
export { ForwardRef as ReactComponent };